/**
 * Well-known vocabulary IRIs used by the model/hops layer to interpret
 * `rdf:type` and structural predicates without needing every bundled
 * ontology's own namespace hard-coded — RDF/RDFS/OWL/SHACL are themselves
 * datasets in this app, so these are the *only* IRIs the engine may treat
 * as "meaning" rather than plain data.
 */

const RDF = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
const RDFS = "http://www.w3.org/2000/01/rdf-schema#";
const OWL = "http://www.w3.org/2002/07/owl#";
const SHACL = "http://www.w3.org/ns/shacl#";

export const VOCAB = {
  rdf: {
    type: `${RDF}type`,
    Property: `${RDF}Property`,
  },
  rdfs: {
    Class: `${RDFS}Class`,
    subClassOf: `${RDFS}subClassOf`,
    subPropertyOf: `${RDFS}subPropertyOf`,
    label: `${RDFS}label`,
    comment: `${RDFS}comment`,
    domain: `${RDFS}domain`,
    range: `${RDFS}range`,
    Datatype: `${RDFS}Datatype`,
  },
  owl: {
    Class: `${OWL}Class`,
    ObjectProperty: `${OWL}ObjectProperty`,
    DatatypeProperty: `${OWL}DatatypeProperty`,
    AnnotationProperty: `${OWL}AnnotationProperty`,
    FunctionalProperty: `${OWL}FunctionalProperty`,
    Ontology: `${OWL}Ontology`,
    equivalentClass: `${OWL}equivalentClass`,
    Restriction: `${OWL}Restriction`,
    onProperty: `${OWL}onProperty`,
    someValuesFrom: `${OWL}someValuesFrom`,
    allValuesFrom: `${OWL}allValuesFrom`,
    hasValue: `${OWL}hasValue`,
    cardinality: `${OWL}cardinality`,
    minCardinality: `${OWL}minCardinality`,
    maxCardinality: `${OWL}maxCardinality`,
    qualifiedCardinality: `${OWL}qualifiedCardinality`,
    minQualifiedCardinality: `${OWL}minQualifiedCardinality`,
    maxQualifiedCardinality: `${OWL}maxQualifiedCardinality`,
    onClass: `${OWL}onClass`,
    onDataRange: `${OWL}onDataRange`,
  },
  sh: {
    NodeShape: `${SHACL}NodeShape`,
    PropertyShape: `${SHACL}PropertyShape`,
    targetClass: `${SHACL}targetClass`,
    property: `${SHACL}property`,
    path: `${SHACL}path`,
    class: `${SHACL}class`,
    datatype: `${SHACL}datatype`,
    minCount: `${SHACL}minCount`,
    maxCount: `${SHACL}maxCount`,
    pattern: `${SHACL}pattern`,
    node: `${SHACL}node`,
    name: `${SHACL}name`,
    description: `${SHACL}description`,
  },
} as const;

/** IRIs that classify a term as a "Class"-like node for the tree/list views. */
export const CLASS_TYPE_IRIS: readonly string[] = [
  VOCAB.rdfs.Class,
  VOCAB.owl.Class,
];

/** IRIs that classify a term as some flavor of "Property". */
export const PROPERTY_TYPE_IRIS: readonly string[] = [
  VOCAB.rdf.Property,
  VOCAB.owl.ObjectProperty,
  VOCAB.owl.DatatypeProperty,
  VOCAB.owl.AnnotationProperty,
  VOCAB.owl.FunctionalProperty,
];
